import { Link } from './Link'
const Survey = () => (
  <div>
    👋 Using “Prefill”? <Link href="https://go.appliger.com/prefill-survey">Take a quick survey</Link>
  </div>
);


export default Survey
